import { render, staticRenderFns } from "./GernreForm.vue?vue&type=template&id=22edacf4&"
import script from "./GernreForm.vue?vue&type=script&lang=js&"
export * from "./GernreForm.vue?vue&type=script&lang=js&"
import style0 from "./GernreForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports